import { Box } from "@mui/material";
import classNames from "classnames";
import * as React from "react";

import CopyToClipboardButton from "@/shared/components/CopyToClipboardButton";

interface PanelTitleProps {
  className?: classNames.Argument;
  title: string | null;
  endAdornment: React.ReactNode | null;
}

/**
 * Display the title of a panel.
 */
export function PanelTitle({
  className,
  title,
  endAdornment: titleSuffix,
}: PanelTitleProps) {
  const [panelTitleHovering, setPanelTitleHovering] =
    React.useState<boolean>(false);
  return (
    <h3
      className={classNames(className)}
      onMouseEnter={() => setPanelTitleHovering(true)}
      onMouseLeave={() => setPanelTitleHovering(false)}
    >
      {title}
      {titleSuffix && (
        // Match the layout of the CopyToClipboardButton.
        <Box
          component="span"
          data-not-draggable="true"
          sx={{ paddingLeft: "6px" }}
        >
          {titleSuffix}
        </Box>
      )}
      {title && (
        <CopyToClipboardButton
          text={title}
          sx={{
            opacity: panelTitleHovering ? 1 : 0,
            transition: "opacity 0.2s",
            paddingLeft: "6px",
          }}
        />
      )}
    </h3>
  );
}
